import { render, staticRenderFns } from "./mine-collection.vue?vue&type=template&id=0f7f71e6&scoped=true&"
import script from "./mine-collection.vue?vue&type=script&lang=js&"
export * from "./mine-collection.vue?vue&type=script&lang=js&"
import style0 from "./mine-collection.vue?vue&type=style&index=0&id=0f7f71e6&prod&lang=scss&"
import style1 from "./mine-collection.vue?vue&type=style&index=1&id=0f7f71e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f71e6",
  null
  
)

export default component.exports